const { Component } = require( "react" );


class ThemePage extends Component{
    render(){
        return (
            <>
                <h1>Headline 1</h1>
                <h2>Headline 2</h2>
                <h3>Headline 3</h3>
                <h4>Headline 4</h4>
                <h5>Headline 5</h5>
                <h6>Headline 6</h6>
                <h6 className="subtitle1">Subtitle 1</h6>
                <h6 className="subtitle2">Subtitle 2</h6>
                <div>
                    <span className="body1">Body 1</span>
                </div>
                <div>
                    <span className="body2">Body 2</span>
                </div>
                <div>
                    <span className="caption">Caption</span>
                </div>
                <div>
                    <span className="overline">Overline</span>
                </div>
                <br/>
                <button className="primary">Primary</button>
                <button className="secondary">Secondary</button>
            </>
        )
    }
}

export default ThemePage;